/**
* @ngdoc component
* @name common.address.component:itxAddressCity
* @description
* Shows a city selector based in the provinceSelected param.
* @param {object} model Address model
* @param {object} form  Form object
* @param {string} class Classes to add to the container 
* @param {object} provinceSelected Selected province.
* @param {boolean} enableDistrict enable district for china
* @param {function} onSelectCity Emits the city object when user selects one.
*/
(function() {
    'use strict';

    var itxAddressCity = {
        bindings: {
            model:'=',
            form:'=',
            completeInfo: '=',
            isChina: '<',
            class:'<',
            provinceSelected:'<',
            enableDistrict:'<',
            isFrance: '<',
            enableCombo: '<',
            provinceDependant:'<',
            onSelectCity:'&'
        },
        controller:   itxAddressCityCtrl,
        templateUrl: 'address-city.component.html'
    };

    itxAddressCityCtrl.$inject = [
        'DUTTI_CONS',
        'StatesService',
        'CountryService',
        'ItxTranslateSvc',
        'crmService',
        'CmsConfigSvc',
        'MdFeelMyAccountService'
    ];

    function itxAddressCityCtrl (
        DUTTI_CONS,
        StatesService,
        CountryService,
        ItxTranslateSvc,
        crmService,
        CmsConfigSvc,
        MdFeelMyAccountService
    ) {
        var _this = this;
        _this.systemPointsEnabled = false;
        _this.isUcrania = inditex.iCountryCode === 'UA';
        _this.isKazajstan = CountryService.is(DUTTI_CONS.country.KZ);
        _this.isEmirates = CountryService.is(DUTTI_CONS.country.AE);
        _this.is200enabled = false;
        _this.is360 = crmService.is360();
        _this.isCityRequired = (_this.completeInfo && _this.is360) || _this.isEmirates;

        _this.$onInit = function () {
            // Comprobacion del estado del sistema de puntos
            CmsConfigSvc.getProperty('feel_points_program_enabled').then(function (systemPointsEnabled) {
                if (systemPointsEnabled) {
                    _this.systemPointsEnabled = true;
                }
            });

            if( (_this.enableCombo && !_this.provinceDependant) || (_this.model.city) ){
                _this.fillCities();
            }
            if(_this.isFrance){
                _this.class="col-xs-6 col-lg-6"
            } else {
                _this.class="col-xs-12 col-lg-6"
            }
            
            if( _this.isUcrania || _this.isKazajstan ){
                _this.placeholderInput = ItxTranslateSvc.translateCms('legacy.ItxLogonPageRegister.district');
            } else {
                _this.placeholderInput = ItxTranslateSvc.translateCms('legacy.ItxLogonPageRegister.city');
            }

            MdFeelMyAccountService.check200PointsEnabled().then(function (isEnabled) {
                _this.is200enabled = true;
            });
        };

        _this.$onChanges = function(changeObj){
            if( (_this.enableDistrict) &&
                changeObj.provinceSelected && 
                changeObj.provinceSelected.currentValue && 
                changeObj.provinceSelected.previousValue!=changeObj.provinceSelected.currentValue) {
                this.model.city = null;
                this.model.district = null;
                _this.updateCities(changeObj.provinceSelected.currentValue);
            }
        };

        _this.fillCities = function(){
            _this.cities = [];
            if(_this.model.stateCode!=null && _this.model.stateCode.length>0 ) {
                _this.updateCities(_this.model.stateCode);
            } else {
                var storeId = CountryService.getStoreIdByCountryCode(_this.model.countryCode);
                StatesService.getStates(storeId, true)
                .then(function(states){
                    if(states.length>0){

                        _this.updateCities(states[0].code);
                    }
                    else{
                        _this.updateCities(null);
                    }
                });
            }
        };

        _this.updateCities = function(stateCode){

            StatesService.getCities(stateCode)
            .then(function(cities) {
                _this.cities = cities;
                if(_this.model.city){
                    _this.selectCity(_this.model.city);
                } else {
                    _this.citySelected = null;
                }
            });
        };
        /**
        * @ngdoc method
        * @name selectCity
        * @methodOf common.address.component:itxAddressCity
        * @description
        * Select the city.
        * It can be selected on component initialization, with the value of the user address:
        * - If the value its ok, it will be id#name
        * - If the value is corrupted, could be a simple string with the name of the city. In this case, is necessary to find the 
        * id in the list of cities.
        * it can be selected in the dropdown.
        * 
        */
        _this.selectCity = function(city){
            if(typeof city !='object'){

                if(typeof city =='string'){

                    if(city.indexOf('#')==-1){
                        var cityFound =_.find(_this.cities, function(item){
                            return item.name == city;
                        });

                        if(cityFound){
                            city = cityFound;
                        } else {
                            return;
                        }
                    } else {
                        city = {
                            id: city.split('#')[0],
                            name: city.split('#')[1]
                        }
                    }
                }
            } else {
                _this.model.city = city.id +'#'+ city.name;
            }
            
            _this.citySelected = city.name;

            _this.onSelectCity({item: city});
        };
    }

    angular.module('itxApp.legacy')
    .component('itxAddressCity',itxAddressCity);

})();
